// Production fallback — the Render backend URL.
// Override by setting REACT_APP_BACKEND_URL in Vercel env vars.
const PRODUCTION_BACKEND = 'https://myarc-backend.onrender.com';

export function getBackendUrl() {
  const raw = (process.env.REACT_APP_BACKEND_URL || '').trim();
  if (raw) return raw.replace(/\/+$/, '');
  if (process.env.NODE_ENV !== 'production') return 'http://localhost:8000';
  return PRODUCTION_BACKEND;
}

export function assertBackendUrl() {
  return getBackendUrl();
}

